import { DocumentoElectronicoService } from 'src/app/services/documento-electronico.service';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { DocumentoElectronicoResumenService } from 'src/app/services/documento-electronico-resumen.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { TipoDTEService } from 'src/app/services/tipo-dte.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { EmpresasRecibidosTableImportacionComponent } from './table-importacion/table-importacion.component';
import { EmpresasRecibidosTableIntercambioEmpresasComponent } from './table-intercambio-empresas/table-intercambio-empresas.component';
import { EmpresasRecibidosTableIntercambioSIIComponent } from './table-intercambio-sii/table-intercambio-sii.component';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import * as _ from 'lodash';

interface IHeaderForm {
  fechaDesde: Date | string;
  fechaHasta: Date | string;
  tipoDocumento: number | null;
  tipoVisor: number;
  statusDocumento: number;
  tipoDetalle: number;
}

@Component({
  selector: 'app-empresas-recibidos',
  templateUrl: './empresas-recibidos.component.html',
  styleUrls: ['./empresas-recibidos.component.scss'],
  providers: [SecurityService],
})
export class EmpresasRecibidosComponent implements OnInit {
  // Children
  @ViewChild(EmpresasRecibidosTableIntercambioEmpresasComponent, { static: true }) intercambioEmpresasComponent: EmpresasRecibidosTableIntercambioEmpresasComponent;
  @ViewChild(EmpresasRecibidosTableIntercambioSIIComponent, { static: true }) intercambioSIIComponent: EmpresasRecibidosTableIntercambioSIIComponent;
  @ViewChild(EmpresasRecibidosTableImportacionComponent, { static: true }) importacionComponent: EmpresasRecibidosTableImportacionComponent;

  onSelectTipoDteCode: number;

  // Form
  formHeader: FormGroup;
  initialValues: IHeaderForm;

  // Data & Tmp
  rutEmpresa: number;
  sucursalCodigo: number;
  loading: boolean = false;
  listaDocumentos: Array<any> = null;
  paginationContext: PaginationContext = new PaginationContext();
  optionsTipoDocumento: Array<any> = [];
  optionsBodega: Array<any> = [];

  currentSearchParams: { empresa_rut: number; desde: any; hasta: any; tipo_dte_codigo: any } = null;
  intercambioEmpresasLoaded: boolean = false;
  intercambioSIILoaded: boolean = false;
  estadoImportacionLoaded: boolean = false;

  showEstadoIntercambioEmpresas: boolean = false;
  showEstadoIntercambioSII: boolean = false;
  showImportacion: boolean = false;

  TIPO_VISOR = Object.freeze({
    ESTADOS: 1,
    IMPORTACION: 2,
  });

  optionsTipoVisor = [
    { value: this.TIPO_VISOR.IMPORTACION, label: 'Importación' },
    { value: this.TIPO_VISOR.ESTADOS, label: 'Estados' },
  ];

  STATUS_DOCUMENTOS = Object.freeze({
    TODOS: 0,
    PENDIENTES: 1,
    REGISTRADOS_ERP: 2,
    NO_PROCESAR: 3,
  });
  optionsStatusDocumento: Array<any> = [];

  TIPO_DETALLE = Object.freeze({
    INTERCAMBIO_EMPRESAS: 1,
    INTERCAMBIO_SII: 2,
  });
  optionsTipoDetalle: Array<any> = [];

  // Utils
  private log: any;

  constructor(
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private datesService: DatesService,
    private tipoDocumentoService: TipoDTEService,
    private documentoElectronicoResumenService: DocumentoElectronicoResumenService,
    private fileDownloadService: FileDownloadService,
    private documentoElectronicoService: DocumentoElectronicoService
  ) {
    this.log = this.clog.log('EMPRESAS-RECIBIDOS');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());

    this.createFormInitialValues();
    this.createForms();
    this.loadTipoDte();
    this.loadFilterOptions();
    this.formChangesSubscriptions();

    this.paginationContext.RecordsByPage = 10;
    this.intercambioEmpresasLoaded = false;
    this.intercambioSIILoaded = false;
    this.buscar(1);
  }

  loadTipoDte() {
    // Tipos documentos
    this.tipoDocumentoService.GetByTipoDte(5, ({ mensajes, respuesta }) => {
      const { registros } = respuesta;
      this.optionsTipoDocumento = registros.map((tipo) => ({ value: tipo.codigo, label: tipo.nombre }));
    });
  }

  createFormInitialValues() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();
    this.initialValues = {
      fechaDesde: initDate,
      fechaHasta: currentDate,
      tipoDocumento: null,
      tipoVisor: null,
      statusDocumento: null,
      tipoDetalle: null,
    };
  }

  private createForms() {
    this.formHeader = this.fb.group({
      fechaDesde: [null, [Validators.required]],
      fechaHasta: [null, [Validators.required]],
      tipoDocumento: [null, []],
      tipoVisor: [null, []],
      statusDocumento: [null, []],
      tipoDetalle: [null, []],
    });

    this.setInitialValues();
  }

  private setInitialValues() {
    this.formValidatorsService.setInitialState(this.formHeader, this.initialValues);
  }

  formChangesSubscriptions() {
    this.formHeader.get('tipoVisor').valueChanges.subscribe((tipoVisor: string) => {
      this.hideAllDetails();

      // habilitar/deshabilitar Tipo Detalles
      if (Number(tipoVisor) === this.TIPO_VISOR.ESTADOS) {
        this.formHeader.get('tipoDetalle').enable();
        this.formHeader.get('tipoDetalle').setValue(this.TIPO_DETALLE.INTERCAMBIO_EMPRESAS);
      } else if (Number(tipoVisor) === this.TIPO_VISOR.IMPORTACION) {
        this.formHeader.get('tipoDetalle').disable();
        this.formHeader.get('tipoDetalle').setValue('');
      }
    });
    this.formHeader.get('tipoDetalle').valueChanges.subscribe((tipoDetalle: string) => {
      if (this.formHeader.get('tipoVisor').value === this.TIPO_VISOR.ESTADOS) this.hideAllDetails();
    });
  }

  loadFilterOptions() {
    this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('tipoVisor'), this.optionsTipoVisor);
    const dat = this.formHeader.get('tipoVisor').value;

    if (Number(dat) === this.TIPO_VISOR.IMPORTACION) {
      this.formHeader.get('tipoDetalle').setValue('');
      this.formHeader.get('tipoDetalle').disable();
    }

    this.optionsStatusDocumento = [
      { value: this.STATUS_DOCUMENTOS.TODOS, label: 'Todos' },
      { value: this.STATUS_DOCUMENTOS.PENDIENTES, label: 'Pendientes' },
      { value: this.STATUS_DOCUMENTOS.REGISTRADOS_ERP, label: 'Registrados' },
      { value: this.STATUS_DOCUMENTOS.NO_PROCESAR, label: 'No procesar' },
    ];

    this.formHeader.get('statusDocumento').setValue(this.STATUS_DOCUMENTOS.PENDIENTES);

    this.optionsTipoDetalle = [
      { value: this.TIPO_DETALLE.INTERCAMBIO_EMPRESAS, label: 'Intercambio entre empresas' },
      // { value: this.TIPO_DETALLE.INTERCAMBIO_SII, label: "Intercambio SII" }, // https://dcore.atlassian.net/browse/ISSTEC-36. Solicitado así
    ];
  }

  hideAllDetails() {
    this.showEstadoIntercambioEmpresas = false;
    this.showEstadoIntercambioSII = false;
    this.showImportacion = false;
  }

  // handleDetailsView() {
  showDetails(tipo_dte_codigo) {
    this.log('showDetails for', tipo_dte_codigo);
    this.onSelectTipoDteCode = tipo_dte_codigo;
    const { tipoVisor, tipoDetalle, statusDocumento } = this.formHeader.value;

    this.hideAllDetails();

    if (!this.listaDocumentos || this.listaDocumentos.length === 0) return;

    // const { tipoVisor, tipoDetalle } = this.formHeader.value
    const { desde, hasta } = this.currentSearchParams;

    // this.log('intercambioEmpresasLoaded', this.intercambioEmpresasLoaded)
    // this.log('tipoVisor', tipoVisor, this.TIPO_VISOR.ESTADOS)
    // this.log('tipoDetalle', tipoDetalle, this.TIPO_DETALLE.INTERCAMBIO_EMPRESAS)

    if (tipoVisor === this.TIPO_VISOR.ESTADOS && tipoDetalle === this.TIPO_DETALLE.INTERCAMBIO_EMPRESAS) {
      // if (!this.intercambioEmpresasLoaded) {
      const success = this.intercambioEmpresasComponent.loadAndShow({
        tipo_dte_codigo,
        desde,
        hasta,
        statusDocumento,
      });
      if (success) {
        this.intercambioEmpresasLoaded = true;
        this.showEstadoIntercambioEmpresas = true;
      }
      // }
      // else
      //   this.showEstadoIntercambioEmpresas = true
    }

    if (tipoVisor === this.TIPO_VISOR.ESTADOS && tipoDetalle === this.TIPO_DETALLE.INTERCAMBIO_SII) {
      // if (!this.intercambioSIILoaded) {
      const success = this.intercambioSIIComponent.loadAndShow({
        tipo_dte_codigo,
        desde,
        hasta,
        statusDocumento,
      });
      if (success) {
        this.intercambioSIILoaded = true;
        this.showEstadoIntercambioSII = true;
      }
      // }
      // else
      //   this.showEstadoIntercambioSII = true
    }

    if (tipoVisor === this.TIPO_VISOR.IMPORTACION) {
      // if (!this.estadoImportacionLoaded) {
      const success = this.importacionComponent.loadAndShow({
        tipo_dte_codigo,
        desde,
        hasta,
        statusDocumento,
      });
      if (success) {
        this.estadoImportacionLoaded = true;
        this.showImportacion = true;
      }
      // }
      // else
      //   this.showImportacion = true
    }
  }

  startSearch() {
    this.intercambioEmpresasLoaded = false;
    this.intercambioSIILoaded = false;

    this.showEstadoIntercambioEmpresas = false;
    this.showEstadoIntercambioSII = false;
    this.showImportacion = false;
    this.buscar(1);
  }

  buscar(pageNumber: number = 1) {
    this.formValidatorsService.validateAllFormFields(this.formHeader);
    if (!this.formHeader.valid) return;

    this.paginationContext.CurrentPage = pageNumber;

    const { fechaDesde, fechaHasta, tipoDocumento, statusDocumento } = this.formHeader.value;

    this.listaDocumentos = [];
    const inputParams = {
      empresa_rut: this.rutEmpresa,
      desde: fechaDesde,
      hasta: fechaHasta,
      tipo_dte_codigo: tipoDocumento ? tipoDocumento : 0,
      statusDocumento: statusDocumento ? statusDocumento : 0,
    };
    this.currentSearchParams = inputParams;

    this.log('inputParams', JSON.stringify(inputParams));

    this.loading = true;
    this.documentoElectronicoResumenService.ObtenerRecibidos(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      this.listaDocumentos = respuesta;
      this.loading = false;

      const { tipoVisor, tipoDetalle } = this.formHeader.value;
      // this.handleDetailsView({ tipoVisor, tipoDetalle })
    });
  }

  limpiarfiltros() {
    this.formHeader.reset();

    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();
    this.formHeader.get('fechaDesde').setValue(initDate);
    this.formHeader.get('fechaHasta').setValue(currentDate);
    this.formHeader.get('tipoVisor').setValue(this.TIPO_VISOR.IMPORTACION);
    this.formHeader.get('statusDocumento').setValue(this.STATUS_DOCUMENTOS.PENDIENTES);
    this.formHeader.get('tipoDetalle').disable();
    this.buscar(1);
  }

  downloadExcel() {
    // delete inputParams.cantidadRegistrosPorPagina
    // delete inputParams.paginaActual

    if (this.showImportacion == true) {
      //Datos correspondientes a la vista Importacion
      const inputParams = _.cloneDeep(this.currentSearchParams);
      inputParams.tipo_dte_codigo = this.onSelectTipoDteCode;
      inputParams.retornaExcel = true;

      this.documentoElectronicoService.obtenerRecibidosImportacion(inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null;
        if (!ok) {
          this.messageRendererService.showErrors(mensajes);
          return;
        }
        if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo);
      });
    } else {
      //Datos correspondientes a la vista General
      const inputParams = _.cloneDeep(this.currentSearchParams);
      this.documentoElectronicoResumenService.ObtenerRecibidosExcel(inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null;
        if (!ok) {
          this.messageRendererService.showErrors(mensajes);
          return;
        }
        if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta);
      });
    }
  }
}
